<template>
  <div>
    获取code
    {{ code }}
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
import { Message } from "element-ui";

export default {
  data() {
    return {
      code: "",
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    getCode() {
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: "ding2392b0260c57e24f35c2f4657eb6378f",
          onSuccess: (result) => {
            /*{
                          code: 'hYLK98jkf0m' //string authCode
                        }*/
            this.code = result;
          },
          onFail: function () {
            // reject(err)

            Message({
              message: "获取用户信息失败，请刷新页面",
              type: "error",
            });
          },
        });
      });
    },
  },
};
</script>

<style>
</style>